__turbopack_context__.v({
  "circular": "IconButton-module-scss-module__CqfJVq__circular",
  "disabled": "IconButton-module-scss-module__CqfJVq__disabled",
  "iconButton": "IconButton-module-scss-module__CqfJVq__iconButton",
  "iconWrapper": "IconButton-module-scss-module__CqfJVq__iconWrapper",
  "lg": "IconButton-module-scss-module__CqfJVq__lg",
  "md": "IconButton-module-scss-module__CqfJVq__md",
  "outline": "IconButton-module-scss-module__CqfJVq__outline",
  "outlineDark": "IconButton-module-scss-module__CqfJVq__outlineDark",
  "primary": "IconButton-module-scss-module__CqfJVq__primary",
  "secondary": "IconButton-module-scss-module__CqfJVq__secondary",
  "sm": "IconButton-module-scss-module__CqfJVq__sm",
  "square": "IconButton-module-scss-module__CqfJVq__square",
  "transparent": "IconButton-module-scss-module__CqfJVq__transparent",
  "xl": "IconButton-module-scss-module__CqfJVq__xl",
});
